import { instance } from "config/axiosInstance";

// note: declare base url
const baseURL = process.env.REACT_APP_TENANT_BE;

export async function getHandOver(pathname, queryParams = "") {
  return await instance({ baseURL: baseURL }).get(pathname + queryParams); // pathname is "/role"
}

export async function createHandOver(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).post("/handover" + pathname, body);
}

export async function completedHandOver(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).post("/handover" + pathname, body);
}

export async function updateHandOver(pathname, queryParams, body) {
  return await instance({
    baseURL: baseURL,
  }).post("/handover" + pathname + queryParams, body);
}

export async function deleteHandOver(pathname, queryParams) {
  return await instance({
    baseURL: baseURL,
  }).post("/hanover" + pathname + queryParams);
}
